import SectionDivider from '@components/profile/teacher/section-divider'
import { useProfileContext } from '@contexts/profile'
import React from 'react'

const TeacherLanguagesSpoken = () => {
  const { profileDetails } = useProfileContext()
  const languages = profileDetails?.teacher?.languagesSpoken || []

  if (languages.length === 0) return null

  return (
    <>
      <SectionDivider />
      <section className="p-5 lg:p-10">
        <h2 className="inline-block bg-orange text-white font-600 rounded px-3 py-1 mb-4">
          Spoken languages
        </h2>
        <ul className="list-disc list-inside space-y-2 text-grey-900 text-base">
          {languages.map((language) => (
            <li key={language}>{language}</li>
          ))}
        </ul>
      </section>
    </>
  )
}

export default React.memo(TeacherLanguagesSpoken)
